import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

const TOKEN_KEY = 'KenindiaBusinessToken';
const REFRESH_TOKEN = 'Refresh-Token';
const CUSTOMER_TOKEN='Customer-Token'
const EXPIRY_TIME = 'Expiry-Time';
const ISTOKEN ='IsToken';
@Injectable()
export class TokenStorage  {

  constructor(private cookieService:CookieService) {
  }

  save(token: any) {
    window.localStorage[TOKEN_KEY] = token;
  }

  get() {
    if (window.localStorage[TOKEN_KEY]) {
      return window.localStorage[TOKEN_KEY];
    } else {
      return ''
    }
  }

  destroy() {
    window.localStorage.removeItem(TOKEN_KEY);
  }

  saveRT(token: any) {
    window.localStorage[REFRESH_TOKEN] = token;
  }

  getRT() {
    if (window.localStorage[REFRESH_TOKEN]) {
      return window.localStorage[REFRESH_TOKEN];
    } else {
      return ''
    }
  }

  destroyRT() {
    window.localStorage.removeItem(REFRESH_TOKEN);
  }
  
  getJWTtoken(){
    const encryptedValue = this.cookieService.get('JWTtoken'); // Get the encrypted token from the cookie
    // const encryptedValue = this.cookieService.get('Uad-Token'); // Get the encrypted token from the cookie

    // Decrypt the token using CryptoJS
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedValue, 'your_secret_key');
    // const decryptedBytes = CryptoJS.AES.decrypt(encryptedValue, environment.tokenDecryptKey);
    
    // Convert the decrypted bytes to a string
    const decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return decryptedToken;
  }
  
  getRefreshToken(){
    // const encryptedValue = this.cookieService.get('RefreshToken'); // Get the encrypted token from the cookie
    const encryptedValue = this.cookieService.get('Refresh-Token'); // Get the encrypted token from the cookie

    // Decrypt the token using CryptoJS
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedValue, 'refresh_token');
    
    // Convert the decrypted bytes to a string
    const decryptedRFToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return decryptedRFToken;
  }
  isToken(isToken: any) {
    window.localStorage[ISTOKEN] = isToken;
  }
  saveExpiryTime(exptime: any) {
    window.localStorage[EXPIRY_TIME] = exptime;
  }
}
